import { boolean, number, object, string, union, literal, z } from "zod";

export const SpecialDealResponseDTOError = object({
  requestDTO: object({
    dataMap: object({
      error: string(),
    }),
  }),
});

export const SpecialDealResponseDTOSuccess = object({
  requestDTO: object({
    processorClass: literal("SpecialDealAndBanners"),
    dataMap: object({
      oneTimeOffer: number(),
      oneTimeOfferPrice: number().optional(),
      isHaveBonusOnReg: boolean(),
      isReferaledUser: boolean().optional(),
      actualDate: string(),
    }),
  }),
});

export type SpecialDealResponseDTOSuccess = z.infer<
  typeof SpecialDealResponseDTOSuccess
>;

export const specialDealDto = (response: SpecialDealResponseDTO) =>
  SpecialDealResponseDTOSuccess.safeParse(response);

export type SpecialDealResponseDTOError = z.infer<
  typeof SpecialDealResponseDTOError
>;

export const SpecialDealResponseDTO = union([
  SpecialDealResponseDTOError,
  SpecialDealResponseDTOSuccess,
]);

export type SpecialDealResponseDTO = z.infer<typeof SpecialDealResponseDTO>;
